function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.643 50.419V20.536c0-1.44 1.008-2.599 2.26-2.599h48.61c1.252 0 2.26 1.16 2.26 2.599v29.883c0 1.44-1.008 2.599-2.26 2.599H3.903c-1.252 0-2.26-1.16-2.26-2.599z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.165 48.491V22.464H43.47v26.027zM49.122 33.554a2.262 2.262 0 012.26 2.263 2.262 2.262 0 11-2.26-2.263zM49.122 42.607a2.262 2.262 0 012.26 2.263 2.262 2.262 0 11-2.26-2.263zM5.6 53.018v1.132c0 .627.504 1.131 1.13 1.131h4.522c.626 0 1.13-.504 1.13-1.131v-1.132zM44.035 53.018v1.132c0 .627.504 1.131 1.13 1.131h4.522c.626 0 1.13-.504 1.13-1.131v-1.132zM49.122 24.501a2.262 2.262 0 012.26 2.263 2.262 2.262 0 11-2.26-2.263z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.556 32.649c2.34 0 3.357-4.526 6.104-4.526s3.66 4.526 6.105 4.526c2.445 0 3.659-4.526 6.104-4.526 2.446 0 3.358 4.526 6.105 4.526 2.747 0 4.374-4.526 6.104-4.526M9.556 41.702c2.34 0 3.357-4.526 6.104-4.526s3.66 4.526 6.105 4.526c2.445 0 3.659-4.526 6.104-4.526 2.446 0 3.358 4.526 6.105 4.526 2.747 0 4.374-4.526 6.104-4.526"
}));

var SvgMicrowave = function SvgMicrowave(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMicrowave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Microwave.f37d1b38.svg";
export { ForwardRef as ReactComponent };